export const characterData = {
  unicorn: {
    name: "獨角獸",
    description: "獨角獸擁有魔法能力，可以幫助你記住節奏！練習時會產生彩色閃光，讓音樂練習更有趣。",
    ability: "節奏魔法",
    favoriteMusic: "歡快的音樂",
    defaultColor: "#5D5CDE",
    effectType: "magic",
    bgEffect: "character-bg-unicorn"
  },
  dragon: {
    name: "小龍",
    description: "小龍的火焰能量讓節拍更加強勁有力！每次重音拍時都會燃起火花，幫助你感受強拍。",
    ability: "火焰節拍",
    favoriteMusic: "熱情的樂曲",
    defaultColor: "#FFB677",
    effectType: "fire",
    bgEffect: "character-bg-dragon"
  },
  panda: {
    name: "熊貓",
    description: "熊貓擁有神奇的平衡感，能幫助你維持穩定的節奏。練習時會輕輕搖擺，讓節拍更流暢。",
    ability: "平衡節奏",
    favoriteMusic: "和諧的曲調",
    defaultColor: "#FFDE59",
    effectType: "bounce",
    bgEffect: "character-bg-panda"
  },
  fox: {
    name: "小狐狸",
    description: "機靈的小狐狸能夠靈活變換節奏！特別適合練習變速和複雜節奏型態，尾巴會隨著節拍擺動。",
    ability: "靈敏變速",
    favoriteMusic: "靈活的節奏",
    defaultColor: "#FF8E8E",
    effectType: "tail",
    bgEffect: "character-bg-fox"
  },
  alien: {
    name: "外星人",
    description: "來自遙遠星球的外星人帶來獨特的宇宙節奏！練習時會發出奇妙的光芒，創造特別的音樂體驗。",
    ability: "宇宙節拍",
    favoriteMusic: "電子音樂",
    defaultColor: "#61DAFB",
    effectType: "glow",
    bgEffect: "character-bg-alien"
  },
  robot: {
    name: "機器人",
    description: "精密的機器人能保持絕對準確的節拍！特別適合需要高度精確性的練習，會發出同步的電子音效。",
    ability: "精準時間",
    favoriteMusic: "精確的節奏",
    defaultColor: "#88EFDD",
    effectType: "beep",
    bgEffect: "character-bg-robot"
  },
  wizard: {
    name: "魔法師",
    description: "神秘的魔法師能夠控制時間流動！練習時能幫助你逐漸提升速度，讓練習更有成效。",
    ability: "時間控制",
    favoriteMusic: "漸進式曲調",
    defaultColor: "#D4B3FF",
    effectType: "magic",
    bgEffect: "character-bg-wizard"
  },
  ninja: {
    name: "忍者",
    description: "敏捷的忍者大師掌握了所有節拍的奧秘！能幫助你輕鬆切換不同拍號，提升複雜曲目的練習效果。",
    ability: "拍號切換",
    favoriteMusic: "變拍子音樂",
    defaultColor: "#5E17EB",
    effectType: "slash",
    bgEffect: "character-bg-ninja"
  },
  princess: {
    name: "音樂公主",
    description: "優雅的音樂公主擁有神奇的音樂魔法！練習時會創造美妙的視覺效果，激發你的音樂靈感。",
    ability: "音樂魔法",
    favoriteMusic: "優美的旋律",
    defaultColor: "#FFAAD4",
    effectType: "sparkle",
    bgEffect: "character-bg-princess"
  },
  superhero: {
    name: "節奏英雄",
    description: "強大的節奏英雄擁有無限的音樂力量！結合所有角色的特殊能力，是音樂大師的象徵。",
    ability: "音樂大師",
    favoriteMusic: "所有類型",
    defaultColor: "#FFDE59",
    effectType: "blast",
    bgEffect: "character-bg-superhero"
  }
};